import "./Login.css";
import React, { useState, useContext, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import UserContext from "../../store/user-context";
const Login = () => {
  //define state
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, isLoading] = useState("");

  const userContext = useContext(UserContext);

  //define state validation
  const [validation, setValidation] = useState(false);

  //define history
  const history = useHistory();

  /**
   * Menggunakan variabel yang bernilai false dan isLoading di set ke false hanya pada saat variable bernilai false
   * adalah cara agar tidak ada error can't perform react ....
   *
   * lebih jelasnya
   * https://www.youtube.com/watch?v=rLiMo8Vk61E
   */
  let isUnmount = false;

  const loginHandler = async (e) => {
    e.preventDefault();
    isLoading(true);
    //initialize formData
    const formData = new FormData();

    //append data to formData
    formData.append("email", email);
    formData.append("password", password);

    //send data to server
    await axios
      .post(process.env.REACT_APP_LINK_API + "login", formData)
      .then((response) => {
        // simpan status login = true
        userContext.loginHandler(response.data);
        isLoading(false);

        //redirect ke url sebelumnya
        history.goBack();
      })
      .catch((error) => {
        //assign error to state "validation"
        isLoading(false);
        setValidation(true);
      });
  };

  // useEffect(() => {
  //   return () => {
  //     isUnmount = true;
  //   };
  // });

  return (
    <div className="container-body">
      <div className="login-page">
        <div className="form">
          <form className="login-form" onSubmit={loginHandler}>
            {validation && (
              <p className="alert-info">Username atau Password Salah</p>
            )}
            <input
              type="email"
              placeholder="Email"
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type="password"
              placeholder="password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <button type="submit">
              {loading && (
                <ClipLoader color={"#ffff"} loading={isLoading} size={15} />
              )}
              {!loading && "Login"}
            </button>
            <p className="message">
              Belum Daftar ? Silahkan Buat <Link to="/">Akun</Link>
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
